<template>
  <div class="align-items-center justify-content-between mb-4">
        <div class="row justify-content-center">   
                    <div class="col-md-10 col-lg-8 col-sm-12">
                        <div class="card shadow mb-4">
                          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 class="m-0 font-weight-bold text-primary">My Agreements </h6>
                          </div>
                            <div class="card-body">
                                <div class="col-12 mb-4" v-if="agreements.length === 0 && success">
                                  <div class="card border-left-primary shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            <p class="p-5">No Agreement Available</p> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 mb-4" v-else-if="loading">
                                  <div class="card border-left-primary shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center justify-content-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                            
                                                <div class="spinner-grow p-4" role="status" v-if="loading">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-12 mb-4" v-for="(agreement, key) in agreements" :key="key" v-else>
                                  <div class="card border-left-primary shadow h-100 py-2">
                                    <div class="card-body">
                                      <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                          <div class="text-xs font-weight-bold text-primary text-uppercase mb-1"></div>
                                          <div class="h5 mb-0 font-weight-bold text-gray-800">
                                             <p> <span class="text-success">Category Name: </span>{{agreement.category_name}}</p>
                                             <p>File <a href="`${url()}/api/${agreement.file}`" download="">Pdf</a></p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="card-footer">
                                        <div class="col-auto">
                                          <button class="btn btn-primary btn-sm mr-2"
                                             type="button" data-toggle="modal" data-target="#exampleModal"
                                             @click="confirmDelete(agreement.id,key, 'isDelete')">
                                                delete
                                             </button> 
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                          </div>
        <!--- start of modal ------>
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel" v-if="isDelete">
                      Do you Really Want To Delete This Agreement?
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                    <p v-if="success" class="text">{{success}}</p>
                </div>
                <div class="modal-footer" v-if="isDelete">
                  <button type="button" class="btn btn-primary" @click="deleteAgreement">Yes
                      <div class="spinner-grow p-4" role="status" v-if="loading">
                             <span class="sr-only">Loading...</span>
                      </div>
                  </button>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
                </div>    
              </div>
            </div>
          </div>
          <!--- end of delete modal box --->
  </div>

</div>
</div>
</template>

<script>
export default {
 data(){
     return {
        isDelete: false,
        key:'',
        agreement_id:'',
     }
 },
 methods:{
     deleteAgreement(){
           this.$store.dispatch('contributor/deleteAgreement', {id:this.agreement_id, key:this.key})
         },
    confirmDelete(id,key){
            this.agreement_id = id;
            this.key = key;
            this.isApprove = false;
            this.isDelete = true;
        },
 },
 computed:{
        agreements() {
            return this.$store.state.contributor.agreements
        },
        success() {
          return this.$store.state.contributor.success;
        },
        loading(){
          return this.$store.state.contributor.loading
        }
    },
    created(){
        this.$store.dispatch('contributor/getUserAgreements')
        //console.log('agreements', this.agreements)
    }
}
</script>

<style>

</style>